import { Component, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { NodeItem } from '../../api/models';
import { StateService } from '../../services/state.service';

@Component({
  selector: 'lib-move-folder',
  templateUrl: './move-folder.component.html',
  styleUrls: ['./move-folder.component.scss'],
  standalone: false,
})
export class MoveFolderComponent implements OnInit {
  itemsToMove: NodeItem[] = [];
  selectedFolder: NodeItem;
  conSitesMode: boolean;
  ngOnInit(): void {}

  constructor(
    private modalCtrl: ModalController,
    private state: StateService
  ) {}

  cancel() {
    return this.modalCtrl.dismiss(null, 'cancel');
  }

  async confirm() {
    await this.state
      .moveNodes(
        this.itemsToMove.map((x) => x.id),
        this.selectedFolder.id
      )
      .then((x) => this.modalCtrl.dismiss(this.selectedFolder.id, 'confirm'));
  }

  currentFolderNodeItemChanged(item: NodeItem) {
    this.selectedFolder = item;
  }
}
